import React, { useEffect, useRef, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { shouldTranslateTo } from '../../utils/utils'
import { SUCCESS } from '../../utils/constants'
import Notification from './../Utils/Notification'
import Form from 'react-bootstrap/Form'
import styled from 'styled-components'
import Error from '../Utils/Error'

import {
  Title,
  Subtitle,
  CustomSubtitle,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const DashLineBox = styled.div`
  margin-top: 10px;
  padding: 30px 15px 40px;
  border-radius: 4px;
  border: 2px dashed #0bac5d;

  form {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    gap: 10px;
  }
`

const PhotoInput = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    width: 220px;
  }
`

const FileButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  margin: 10px auto 0;
  padding: 10px 10vw;
`

const ChooseButton = styled(FileButton)`
  background-color: #e78b00;
  border: 0;
  color: #fff;
`

const ImageLoadingButton = styled(ActionButtons)`
  margin: 10px auto;
  padding: 10px 10vw;
`

const ImageIsLoadingButton = styled(LoadingButton)`
  margin: 10px auto;
  padding: 10px 10vw;
`

const ChangePhoto = styled(PhotoInput)`
  display: block;
`

const ButtonBox = styled.div`
  display: block;
  width: 100%;
`

const FormContent = styled.div`
  width: 40vw;
  min-width: 250px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  button {
    width: -webkit-fill-available;
  }
`

const DobPicker = styled(Form.Control)`
  padding: 26px 26px 26px 15px;
  font-size: 18px;
  border-radius: 4px;
  border: 1px solid rgba(17, 17, 19, 0.39);
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Source Sans Pro', sans-serif !important;

  &.error-border {
    border: 3px solid red;
  }
`

const ErrorWrapper = styled.div`
  margin: 20px 0 0 0;
  padding: 0;

  > div {
    padding: 0;
    > label {
      margin: 0 !important;
    }
  }
`

const ProofIdentityApp = ({ data, onUpdate }) => {
  const [responseMessage, setResponseMessage] = useState('')
  const [dob, setDob] = useState('')
  const [dobError, setDobError] = useState(false)
  const [file, setFile] = useState(null)
  const [filePreview, setFilePreview] = useState(null)
  const [fileName, setFileName] = useState('')
  const [chooseDobDisplay, setChooseDobDisplay] = useState('block')
  const [choosePhotoDisplay, setChoosePhotoDisplay] = useState('none')
  const [chosenPhotoDisplay, setChosenPhotoDisplay] = useState('none')
  const [uploadButtonDisplay, setUploadButtonDisplay] = useState('none')
  const [changePhotoDisplay, setChangePhotoDisplay] = useState('none')
  const [uploadNewId, setUploadNewId] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [pageText, setPageText] = useState([])

  const hiddenFileInput = useRef(null)

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('upload-photo-id', language)
  }, [])

  const handleClick = (e) => {
    e.preventDefault()
    hiddenFileInput.current.click()
  }

  const handleDobChoice = (event) => {
    setDobError(false)
    setError('')
    const target = event.target
    const dob = target.value
    setDob(dob)
  }

  const handleDobSubmit = (e) => {
    e.preventDefault()

    if (!dob) {
      setDobError(true)
      setError(`${pageText[9]}`)
      return
    }

    const dobDetails = {
      dob: dob,
    }
    data.auth.updateUser(dobDetails)
    setChooseDobDisplay('none')
    setChoosePhotoDisplay('block')
  }

  const handleChange = (e) => {
    setFilePreview(URL.createObjectURL(e.target.files[0]))
    setFile(e.target.files[0])
    setFileName(e.target.files[0].name)
    setChoosePhotoDisplay('none')
    setChosenPhotoDisplay('block')
    setUploadButtonDisplay('flex')
    setChangePhotoDisplay('block')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)
    setResponseMessage('')

    const formData = new FormData()
    formData.append('file', file)
    const headers = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    axios
      .post('/api/upload-proof', formData, headers)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: `${pageText[10]}`,
        })

        const photoIdDetails = {
          proofIdentityStatus: 'completed',
        }

        data.auth.updateUser(photoIdDetails)

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        setTimeout(function () {
          onUpdate()
        }, 1000)
      })
      .catch((e) => {
        setResponseMessage(`${pageText[11]}`)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleUploadNew = () => {
    if (data.auth.user.dob !== '1968-01-01') {
      setChooseDobDisplay('none')
      setChoosePhotoDisplay('block')
    }
    setUploadNewId(true)
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[12]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      {data.auth.user.proofIdentityStatus === 'completed' &&
      uploadNewId === false ? (
        <>
          <Title
            center
            size="29px"
            sizemd="29px"
            sizesm="24px"
            margin="0"
            dangerouslySetInnerHTML={{
              __html: `${pageText[7]}`,
            }}
          ></Title>
          <CustomSubtitle
            center
            size="18px"
            margin="15px 0 34px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[8]}`,
            }}
          />
          <DashLineBox>
            <ChooseButton onClick={handleUploadNew}>
              {pageText[13]}
            </ChooseButton>
          </DashLineBox>
        </>
      ) : (
        <>
          <Title
            center
            size="29px"
            sizemd="29px"
            sizesm="24px"
            margin="0"
            dangerouslySetInnerHTML={{
              __html: `${pageText[0]}`,
            }}
          ></Title>
          <CustomSubtitle
            center
            size="18px"
            margin="15px 0 34px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[1]}`,
            }}
          />
          <DashLineBox>
            <form
              method="POST"
              action="/"
              name="myForm"
              aria-label="Verify photo"
              onSubmit={(event) => {
                event.preventDefault()
                handleSubmit(event)
                return false
              }}
            >
              <input
                type="hidden"
                name="csrf-token"
                value={window.Laravel.csrfToken}
              />

              <FormContent style={{ display: chooseDobDisplay }}>
                <Title
                  size="21px"
                  sizemd="21px"
                  sizesm="21px"
                  margin="0 0 16px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[14]}`,
                  }}
                ></Title>
                <DobPicker
                  type="date"
                  className={dobError && 'error-border'}
                  onChange={(e) => handleDobChoice(e)}
                />
                <Subtitle
                  color="#7c7c7c"
                  weight="400"
                  margin="10px 0 15px"
                  size="16px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[21]}`,
                  }}
                />
                <ActionButtons
                  type="submit"
                  padding="10px 10px"
                  margin="40px 0 0 0"
                  onClick={(e) => handleDobSubmit(e)}
                >
                  {pageText[15]}
                </ActionButtons>
                <ErrorWrapper>{error && <Error error={error} />} </ErrorWrapper>
              </FormContent>

              <FormContent style={{ display: choosePhotoDisplay }}>
                <Title
                  center
                  size="21px"
                  sizemd="21px"
                  sizesm="21px"
                  margin="0 0 16px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[22]}:`,
                  }}
                ></Title>
                <ChooseButton onClick={handleClick}>
                  {pageText[16]}
                </ChooseButton>
                <input
                  type="file"
                  onChange={(e) => handleChange(e)}
                  ref={hiddenFileInput}
                  style={{ display: 'none' }}
                />
              </FormContent>
              <Subtitle
                center
                weight="400"
                margin="0 0 15px"
                style={{ display: chosenPhotoDisplay }}
                dangerouslySetInnerHTML={{
                  __html: `<strong>${pageText[17]}</strong>`,
                }}
              />
              {chosenPhotoDisplay == 'block' ? (
                <img
                  src={filePreview}
                  style={{ width: '100%', maxWidth: '250px' }}
                />
              ) : (
                <Subtitle
                  center
                  size="18px"
                  margin="30px 60px 0 60px"
                  marginmd="30px 40px 0 40px"
                  marginsm="30px 20px 0 20px"
                  weight="400"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[6]}`,
                  }}
                />
              )}
              <ButtonBox>
                {isLoading ? (
                  <ImageIsLoadingButton padding="10px 9vw">
                    {pageText[18]}
                  </ImageIsLoadingButton>
                ) : (
                  <ImageLoadingButton
                    type="submit"
                    padding="10px 10vw"
                    style={{ display: uploadButtonDisplay }}
                  >
                    {pageText[19]}
                  </ImageLoadingButton>
                )}
              </ButtonBox>
              <ChangePhoto style={{ display: changePhotoDisplay }}>
                <Subtitle
                  center
                  weight="400"
                  margin="10px 0 19px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[23]}`,
                  }}
                />

                <FileButton onClick={handleClick}>{pageText[20]}</FileButton>
              </ChangePhoto>
            </form>
          </DashLineBox>
        </>
      )}
    </ContainerBox>
  )
}

export default withRouter(withAuth(ProofIdentityApp))
